import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from '@angular/router';
import { ENVIRONMENT } from '../../../../environments/environment.interface';
import { IntegrationServiceOffice } from '../../../api/app-types/integration-office.app';
import { INTEGRATION_OFFICE_SERVICE } from '../../../api/services/integration-office.service';
import { PaginatedResponse } from '../../pagination/paginated-response';

export const integrationOfficesResolver: ResolveFn<PaginatedResponse<IntegrationServiceOffice>> = async (
	_route: ActivatedRouteSnapshot,
	_state: RouterStateSnapshot,
) => {
	const api = inject(INTEGRATION_OFFICE_SERVICE);
	const env = inject(ENVIRONMENT);
	const response = await api.getAll(env.pagination.offset, env.pagination.range);
	return response;
};

export const integrationOfficeResolver: ResolveFn<IntegrationServiceOffice> = async (
	route: ActivatedRouteSnapshot,
	_state: RouterStateSnapshot,
) => {
	const api = inject(INTEGRATION_OFFICE_SERVICE);
	const id = route.paramMap.get('id');
	const response = await api.getById(id!);
	return response;
};
